export const achievementData = {
    bio : "It's wonderful to have quantifiable accomplishments on a résumé, but I don't deal with statistics. I don't have any evidence to back up the quality of my work. If you have a lot of relevant experience, your resume's heading statement will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Build a Full Website using WordPress',
            details : 'Coursera certifies their successful completion of Build a Full Website using WordPress',
            date : 'Feb 24, 2019',
            field : 'Development',
            image : 'https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~JM3LZXB3QCH9/CERTIFICATE_LANDING_PAGE~JM3LZXB3QCH9.jpeg'
        },
        {
            id : 2,
            title : 'Android Game Development: Build Math based Game',
            details : 'This certificate verifies that MD. Ashrak Al Arif Shohas successfully completed the course taught by Sandip Bhattacharya on Udemy.',
            date : 'Aug 20, 2019',
            field : 'Development',
            image : 'https://udemy-certificate.s3.amazonaws.com/image/UC-08a2b74d-8ce5-4f0a-ada3-6f9443aae1f7.jpg?v=1614155060000'
        },
        {
            id : 3,
            title : 'Complete Web Development Course With Jhankar Mahbub',
            details : 'To become a Complete Full Stack Web Developer.',
            date : 'july 01, 2021',
            field : 'Development',
            image : 'https://play-lh.googleusercontent.com/jpadzS0BMgmRxtqpM1ki804FY0a1hYMxYgHT_fiGlFQKX_tnMDxu7BmiCiEaXVPHZLw'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/